import React, { Component } from 'react'
import { Field, Form } from 'redux-form'
import { Elements, ElementsConsumer, AuBankAccountElement } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

import { Input } from '../../../components/Input/Input'
import { vRequired, vEmail } from '../../../components/Input/Input.validations'
import Button from '../../../components/Button'
import InputMessage from '../../../components/Input/InputMessage'
import config from 'src/config'

import s from './BillingAddBankAccountForm.scss'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sMarg from 'styles/modules/margins.scss'
import sText from 'components/Text/Text.scss'

const stripe = loadStripe(config.other.stripePublicKey)

export default class BillingAddBankAccountForm extends Component {
  state = {
    bankAccount: {
      error: undefined,
      empty: true,
      complete: false,
    },
    submitting: false,
  }

  componentWillMount() {
    const {
      setupBankAccount,
      billingAccount: { ban },
    } = this.props

    setupBankAccount({ ban })
  }

  render() {
    const {
      handleSubmit,
      formData,
      onCancel,
      clientSecret,
      loading,
      updateBankAccount,
      billingAccount: { ban },
    } = this.props

    const AU_BANK_ACCOUNT_ELEMENT_OPTIONS = {
      style: {
        base: {
          fontSize: '20px',
        },
      },
      disabled: false,
      hideIcon: false,
      iconStyle: 'default', // or "solid"
    }

    return (
      <Elements stripe={stripe}>
        <ElementsConsumer>
          {({ elements, stripe }) => {
            const onSubmit = async () => {
              this.setState({ submitting: true })

              const result = await stripe.confirmAuBecsDebitSetup(clientSecret, {
                payment_method: {
                  au_becs_debit: elements.getElement(AuBankAccountElement),
                  billing_details: {
                    name: formData.name,
                    email: formData.email,
                  },
                },
              })

              if (result.error || !result.setupIntent) {
                const error = result.error || { message: 'Something goes wrong, please retry' }
                this.setState({
                  bankAccount: {
                    error,
                  },
                })
                console.log(error)
                this.setState({ submitting: false })
              } else {
                // send payment method to backend
                await updateBankAccount({
                  ban,
                  paymentMethodId: result.setupIntent.payment_method,
                })

                if (this.props.afterSubmit) {
                  this.props.afterSubmit()
                }
              }
            }

            return (
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Field
                  name="name"
                  label="Name"
                  component={Input}
                  validate={[vRequired]}
                  placeholder="John Smith"
                  labelUp={true}
                />

                <Field
                  name="email"
                  label="Email Address"
                  placeholder="john.smith@company.com"
                  component={Input}
                  validate={[vRequired, vEmail]}
                  labelUp={true}
                />

                <div className={s['form-row']}>
                  <label>
                    Bank Account
                    <AuBankAccountElement
                      options={AU_BANK_ACCOUNT_ELEMENT_OPTIONS}
                      onChange={event => {
                        this.setState({
                          bankAccount: {
                            error: event.error,
                            empty: event.empty,
                            complete: event.complete,
                          },
                        })
                      }}
                    />
                  </label>
                  <InputMessage error={this.state.bankAccount.error?.message} touched />
                </div>

                <div className={cn(sText.descrip4, sMarg.mv30)}>
                  1.3% payment surcharge applies.{' '}
                  <a
                    href="https://helpcentre.thinkpickle.com.au/account-management/avoiding-credit-card-surcharge"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn more.
                  </a>
                </div>

                <div className={s['mandate-acceptance']}>
                  By providing your bank account details, you agree to this Direct Debit Request and
                  the{' '}
                  <a
                    href="https://thinkpickle.com.au/legal/becs-direct-debit-request-service-agreement"
                    target="_blank"
                  >
                    Direct Debit Request service agreement
                  </a>
                  , and authorise Stripe Payments Australia Pty Ltd ACN 160 180 343 Direct Debit
                  User number 507156 (“Stripe”) to debit your account through the Bulk Electronic
                  Clearing (BECS) on behalf of THINK PICKLE PTY LIMITED (the "Merchant") for any
                  amounts communicated to you by the Merchant. You certify that you are either an
                  account holder or an authorised signatory on the account listed above.
                </div>

                <div
                  className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
                  style={{ marginTop: '40px' }}
                >
                  <Button
                    color="tertiary"
                    type="submit"
                    loading={loading || this.state.submitting}
                    disabled={
                      !stripe ||
                      !elements ||
                      !this.state.bankAccount.complete ||
                      loading ||
                      this.state.submitting
                    }
                  >
                    Save
                  </Button>
                  <br />
                  <br />
                  <Button plain onClick={onCancel}>
                    Cancel
                  </Button>
                </div>
              </Form>
            )
          }}
        </ElementsConsumer>
      </Elements>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAddBankAccountForm/BillingAddBankAccountForm.jsx